function mbProdSlider() {
  var $viewport = $(".carousel__viewport");
  var $btn = $(".gallery_overlap_button"); // mobile button

  // Visible slides (prefer class, fallback to :visible)
  var $slides = $viewport.find('li.carousel__slide.visible_cell');
  if (!$slides.length) $slides = $viewport.find('li:visible');

  var numItems = $slides.length;

  // Bullets container visibility
  $(".slider_bullets").toggle(numItems >= 1);

  // Individual bullets visibility
  $(".slider_bullet").each(function (index) { $(this).toggle(index < numItems); });

  // Update bullet fill + hidden input
  var updateActiveBullet = function (scrollPercentage, mediaCount) {
    var m = mediaCount || 1;
    var scrollBreakpoint = 100 / m;
    var activeBulletIndex = Math.ceil(scrollPercentage / scrollBreakpoint);
    if (scrollPercentage === 0) activeBulletIndex = 1;
    if (activeBulletIndex < 1) activeBulletIndex = 1;
    if (activeBulletIndex > m) activeBulletIndex = m;

    $("#active_bullet").val(String(activeBulletIndex));
    $(".slider_bullet").css("background", "none");
    $("#bullet_" + activeBulletIndex).css("background", "#101010");
    return activeBulletIndex; // 1-based
  };

  function ensureVideoLoaded($li) {
    var $vid = $li.find("video.mobile_gallery_video");
    if (!$vid.length) return;
    if ($vid.find("source").length === 0) {
      var src = $vid.attr("data-src");
      if (src) {
        $vid.append('<source src="' + src + '" type="video/mp4">');
        var v = $vid.get(0);
        v.preload = "metadata";
        v.muted = true;
        v.load();
      }
    }
    try { $vid.get(0).play(); } catch (e) {}
  }
  function unloadVideo($li) {
    var $vid = $li.find("video.mobile_gallery_video");
    if (!$vid.length) return;
    var v = $vid.get(0);
    try { v.pause(); } catch (e) {}
    $vid.find("source").remove();
    v.load(); // reset to poster
  }

  function updateByScroll() {
    var el = $viewport.get(0);
    if (!el) return;

    // refresh $slides in case visibility changed since init
    $slides = $viewport.find('li.carousel__slide.visible_cell');
    if (!$slides.length) $slides = $viewport.find('li:visible');

    var mediaCount = $slides.length || 1;
    var maxScrollable = (el.scrollWidth - el.clientWidth) || 1;
    var scrollPercentage = 100 * $viewport.scrollLeft() / maxScrollable;

    var activeBullet1 = updateActiveBullet(scrollPercentage, mediaCount);
    var activeIdx = activeBullet1 - 1; // zero-based

    // Show mobile button only on the first slide
    $btn.toggle(activeIdx === 0);

    if (window.updateGalleryButton) window.updateGalleryButton();

    // Lazy-load active video and ±1 neighbor; unload the rest
    $slides.each(function (i) {
      var $li = $(this);
      if ($li.find("video.mobile_gallery_video").length === 0) return;
      if (Math.abs(i - activeIdx) <= 1) ensureVideoLoaded($li);
      else unloadVideo($li);
    });
  }

  // Initial bullet/btn/video state
  if ($viewport.scrollLeft() === 0) {
    $(".slider_bullet").css("background", "none");
    $("#bullet_1").css("background", "#101010");
    $("#active_bullet").val("1");
  }
  updateByScroll();

  // Debounced scroll binding
  var rafId = null;
  $viewport.off("scroll.mbProd").on("scroll.mbProd", function () {
    if (rafId) return;
    rafId = requestAnimationFrame(function () { rafId = null; updateByScroll(); });
  });

  // Keep state on resize
  $(window).off("resize.mbProd").on("resize.mbProd", updateByScroll);

  // Button: snap to the second visible slide
  $(document).off("click.mbProd", ".gallery_overlap_button")
    .on("click.mbProd", ".gallery_overlap_button", function (e) {
      e.preventDefault();
      // use current $slides to respect visibility
      var $second = $slides.eq(1);
      if ($second.length) {
        $second.get(0).scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
      }
    });
}

$(function () {
  var mql = window.matchMedia('(max-width: 767px)');
  function initIfMobile(e) {
    if (e && !e.matches) return; 
    setTimeout(function () { 
      if (typeof mbProdSlider === 'function') mbProdSlider();
    }, 50);
  }
  initIfMobile(mql);
  if (mql.addEventListener) mql.addEventListener('change', initIfMobile);
  else mql.addListener(initIfMobile);
});
